import { render, staticRenderFns } from "./goodsTable.vue?vue&type=template&id=c41b4e1c&scoped=true"
import script from "./goodsTable.vue?vue&type=script&lang=js"
export * from "./goodsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41b4e1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c41b4e1c')) {
      api.createRecord('c41b4e1c', component.options)
    } else {
      api.reload('c41b4e1c', component.options)
    }
    module.hot.accept("./goodsTable.vue?vue&type=template&id=c41b4e1c&scoped=true", function () {
      api.rerender('c41b4e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/clientAnddistributionChild/goodsTable.vue"
export default component.exports